import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Card, CardBody, CardHeader, Table} from "reactstrap";
import PolyUtil from "../../../util/PolyUtil";

class PaymentHistory extends Component {
    render() {
        const billing_history = this.props.billing_history;

        return (
            <Card className="pr-card">
                <CardHeader tag="h4">Payment History</CardHeader>
                <CardBody>
                    {PolyUtil.validArr(billing_history) ? (
                        <Table striped responsive>
                            <thead>
                            <tr>
                                <th>Status</th>
                                <th>Amount</th>
                                <th>Card</th>
                            </tr>
                            </thead>
                            {
                                <tbody>
                                {
                                    billing_history.map(function (hist, i) {
                                        return (
                                            <tr key={i}>
                                                <td className={hist.status === 'succeeded' && 'text-success'}>{PolyUtil.formatTitleCase(hist.status)}</td>
                                                <td>{PolyUtil.formatUSD(hist.amount)}</td>
                                                <td>{hist.source ? (hist.source.brand + " *" + hist.source.last4) : null}</td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            }
                        </Table>
                    ) : (
                        <p>No payment history available.</p>
                    )
                    }
                </CardBody>
            </Card>
        );
    }
}

const mapStateToProps = (state) => ({
    billing_history: state.tenant.billing.history
});

export default connect(mapStateToProps)(PaymentHistory);


// WEBPACK FOOTER //
// ./src/containers/tenant/billing/PaymentHistory.js